import axios from "@/api/axiosInstance";
import {
  ValidateStagePositionRequest,
  ValidateStagePositionResponse,
} from "./types";

export const validateStagePosition = async (
  requestData: ValidateStagePositionRequest,
): Promise<ValidateStagePositionResponse> => {
  const response = await axios.post<ValidateStagePositionResponse>(
    "/api/private/admin/stages/validate-position",
    requestData,
  );
  return response.data;
};
